import * as React from 'react';
export const giftSvg = React.forwardRef(function giftSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.757 1.724C9.659.694 10.914 0 12.25 0A2.77 2.77 0 0 1 15 2.75c0 .988-.488 1.729-1.177 2.27A2.5 2.5 0 0 1 16 7.5v6a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 13.5v-6a2.5 2.5 0 0 1 2.177-2.48C1.488 4.48 1 3.739 1 2.75A2.77 2.77 0 0 1 3.75 0c1.336 0 2.591.695 3.493 1.724.286.327.542.691.757 1.086.216-.395.47-.76.757-1.086Zm.058 3.254c1.165-.064 2.288-.267 3.153-.619C13.06 3.916 13.5 3.356 13.5 2.75a1.27 1.27 0 0 0-1.25-1.25c-.81 0-1.68.43-2.365 1.213a4.623 4.623 0 0 0-1.07 2.265ZM2.5 14.5h4.75v-3.25H1.5v2.25a1 1 0 0 0 1 1Zm-1-4.75V7.5a1 1 0 0 1 1-1h2.746c-.395.285-.76.594-1.056.89a.65.65 0 0 0 .92.92 7.8 7.8 0 0 1 1.488-1.143c.232-.137.452-.247.652-.33V9.75H1.5Zm7.25 1.5v3.25h4.75a1 1 0 0 0 1-1v-2.25H8.75Zm5.75-1.5H8.75V6.837c.2.083.42.193.652.33a7.794 7.794 0 0 1 1.489 1.142.65.65 0 1 0 .919-.919 8.805 8.805 0 0 0-1.055-.89H13.5a1 1 0 0 1 1 1v2.25Zm-12-7c0-.675.575-1.25 1.25-1.25.81 0 1.68.43 2.365 1.213.53.604.922 1.389 1.07 2.265-1.165-.064-2.288-.267-3.153-.619C2.94 3.916 2.5 3.356 2.5 2.75Z',
    }),
  );
});
giftSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gift = {
  category: 'icon',
  colorable: true,
  name: 'gift',
  svg: giftSvg,
};
